import AlternativesPage from '@/components/Pages/AlternativesPage';

export default AlternativesPage;
